module.exports = __webpack_public_path__ + "img/f7.03988adf.png";